import { render, staticRenderFns } from "./ReplacePeiTransitionStudentSAEE12Document.vue?vue&type=template&id=f26b8094&scoped=true"
import script from "./ReplacePeiTransitionStudentSAEE12Document.vue?vue&type=script&lang=js"
export * from "./ReplacePeiTransitionStudentSAEE12Document.vue?vue&type=script&lang=js"
import style0 from "./ReplacePeiTransitionStudentSAEE12Document.vue?vue&type=style&index=0&id=f26b8094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26b8094",
  null
  
)

export default component.exports